/** Normalize page values from API/state to a positive integer. */
export const toPageNumber = (value, fallback = 1) => {
  const n = Number(value);
  return Number.isFinite(n) && n >= 1 ? Math.floor(n) : fallback;
};

/** Clamp when total pages shrink; return current if unchanged (stable for React). */
export const clampPageToTotal = (current, totalPages) => {
  const maxPage = toPageNumber(totalPages, 1);
  const page = toPageNumber(current, 1);
  const next = Math.min(page, maxPage);
  return next === page ? page : next;
};
